/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChatEventEmodjiReceivedContentDto { 
    /**
     * id сообщения
     */
    messageId: string;
    /**
     * Временная метка сообщения
     */
    timestamp: number;
    /**
     * id чата, в котором событие
     */
    chatId: string;
    /**
     * id пользователя - отправитель сообщения
     */
    senderUserId: string;
    /**
     * имя пользователя-отправителя
     */
    senderUserName: string;
    /**
     * идентификатор сообщения, на которое отвечает текущее сообщение
     */
    replyMessageId?: string | null;
    /**
     * текст цитаты из сообщения ReplayMessageId
     */
    replyMessageText?: string | null;
    /**
     * Время создания сообщения
     */
    createdAt: number;
    /**
     * значение emodji
     */
    emodgi: string;
}

